export interface ILateDonorReviews {

    id: number;
    donorCenterId: number;
    donorCenterAlias: string;
    donorId: number;
    donorIsExportable: false;
    donorAlias: string;
    recipientCenterId: number;
    recipientCenterAlias: string;
    recipientId: number;
    recipientAlias: string;
    recipientIsExportable: false;
    dateRequested: string;
    responseDateTime: string;
    responseDetails: string;
    safeKey: string;
    expectedResponseDate: string;
    secondsLate: number;
    daysLate1: number;
    isLate: boolean;
    isPending: boolean;
    daysLate: number;
}
